import { Outlet } from "react-router-dom";
import { AccessNotice } from "./AccessNotice";

/**
 * Wraps every shop page so the sign in banner shows in all of them.
 */
export const ShopLayout = () => {
  return (
    <>
      <AccessNotice />
      <Outlet />
    </>
  );
};
